import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingExtrasPage } from '../../../../../features/parking/ui/booking-pages/new-booking/NewBookingExtrasPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingExtrasPage;
